import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import LoaderMark from './LoaderMark';
import { Container, VisuallyHidden } from './StyledComponents';
import { claimLoaderPhase } from './loaderTimeline';

interface LoadingLogoProps {
  contained?: boolean;
}

const LoadingLogo: React.FunctionComponent<LoadingLogoProps> = ({ contained = false }) => {
  const { t } = useTranslation('common');
  // Claimed once per mount. Three different places show this component during a cold boot,
  // so it picks up the shared loop rather than restarting it — see loaderTimeline.ts.
  const [phase] = useState(claimLoaderPhase);

  return (
    <Container $contained={contained}>
      <LoaderMark delayMs={phase.markDelayMs} />
      {/* The mark is decorative and aria-hidden, so this is the only thing announcing the
          loading state. It carries no visible weight — removing it would leave screen
          reader users with silence while the app boots. */}
      <VisuallyHidden role="status">{t('loading.generic')}</VisuallyHidden>
    </Container>
  );
};

export default LoadingLogo;
